import type { Permission } from '@ztechapps/common.contract'

export const orderPermissions = {
  canView: {
    value: 'order.canView',
    label: 'Can View',
    description: 'No modification can be done to the order, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'order.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of order',
  } satisfies Permission,
}
